import { hbs } from 'ember-cli-htmlbars';
export default hbs('<div class=\"o--blank o--blank--full\">\n  <h2>{{t \"app.no_groups\"}}</h2>\n  <h3><LinkTo @route=\"account\">{{t \"header.settings.settings\"}}</LinkTo></h3>\n</div>', { moduleName: 'later/templates/nogroup.hbs' });
